import { render } from "./BrowseView.vue?vue&type=template&id=12e5e642&scoped=true"
import script from "./BrowseView.vue?vue&type=script&lang=js"
export * from "./BrowseView.vue?vue&type=script&lang=js"

import "./BrowseView.vue?vue&type=style&index=0&id=12e5e642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e5e642"]])

export default __exports__